import React from "react";

import SettingsPanel from "../../components/SettingsPanel";
import CustomerOnboarding from "../../../Customer/single/onboarding";

// Company Settings > Onboarding.
//
// Onboarding here means onboarding THIS company onto the CRMit platform —
// setting up their own instance (statuses, types, billable items, integrations,
// imports), not onboarding one of their customers. It is company-level: each
// company has its own database, so there is exactly one onboarding checklist for
// the logged-in company, find-or-created when this screen opens. Hence no
// customer picker — the checklist just loads for the current company.
export default function CompanyOnboarding() {
  return (
    <SettingsPanel
      title="Onboarding"
      description="Work through the checklist to set this company up on the CRMit platform. Jump between sections in any order, set a status on each step, capture answers, and park anything you're waiting on."
    >
      <CustomerOnboarding companyMode />
    </SettingsPanel>
  );
}
